export default __webpack_public_path__ + "static/media/success-green.f98920ce.svg";